import { render, staticRenderFns } from "./userDialog.vue?vue&type=template&id=d24846b2&scoped=true"
import script from "./userDialog.vue?vue&type=script&lang=js"
export * from "./userDialog.vue?vue&type=script&lang=js"
import style0 from "./userDialog.vue?vue&type=style&index=0&id=d24846b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24846b2",
  null
  
)

export default component.exports